import { useEffect, useState } from 'react'

const original = [
  'iluminando sua experiência...',
  'acendendo as melhores ofertas...',
  'brilhando mais que LED de vitrine...',
  'procurando a luz no fim do túnel... encontramos!',
  'carregando watts de qualidade...',
  'deixando tudo menos obscuro...',
  'trazendo luz para sua decisão...',
  'preparando o destaque do seu ambiente...',
  'esquentando as lâmpadas... (é rápido, prometo)',
  'conectando você ao que há de mais brilhante...',
  'nossa entrega é rápida, mas a luz é instantânea...',
  'alumiando as melhores opções...',
  'carregando lumens de inspiração...',
  'tá quase... mais rápido que trocar uma lâmpada!',
  'buscando produtos que fazem seu dia brilhar...',
  'clarificando suas opções...',
  'menos escuridão, mais economia...',
  'brilho na tela, brilho em casa...',
  'carregando seu futuro mais iluminado...',
  'acendemos rápido, você decide mais rápido ainda...',
  'procurando a peça que falta no seu lustro...',
  'trazendo luz (e frete grátis)...',
  'seu ambiente pedindo um upgrade luminoso...',
  'preparando o spotlight para você...',
  'mais luz, menos conta de energia...',
  'iluminando desde o Oiapoque ao Chuí...',
  'carregando o catálogo mais brilhante do Brasil...',
  'deixa com a gente, a gente entende de luz...',
  'do Magalu ao Mercado Livre, iluminando tudo...',
  'brilhando em todos os marketplaces...',
  'sua casa merece esse upgrade luminoso...',
  'preparando as ofertas que vão te deixar de olhos arregalados...',
  'carregando inovação que não queima no bolso...',
]

export function useRandomMessage() {
  const [_, setMessages] = useState(original)
  const [currentMessage, setCurrentMessage] = useState('')

  function chooseMessage() {
    setCurrentMessage('')

    setMessages((prevMessages) => {
      if (prevMessages.length > 0) {
        const index = Math.floor(Math.random() * prevMessages.length)
        const message = prevMessages[index]
        setCurrentMessage(message)
        return prevMessages.filter((msg) => msg !== message)
      } else {
        // Reseta e escolhe da lista original
        const index = Math.floor(Math.random() * original.length)
        const message = original[index]
        setCurrentMessage(message)
        return original.filter((msg) => msg !== message)
      }
    })
  }

  useEffect(() => {
    chooseMessage()
    const intervalId = setInterval(chooseMessage, 5000)
    return () => clearInterval(intervalId)
  }, [])

  return currentMessage
}
